export enum InputType {
  TEXT = "text",
  TEL = "tel",
  EMAIL = "email",
  NUMBER = "number",
  DATE = "date",
  DROPDOWN = "select",
  RADIO = "radio",
  CHECKBOX = "checkbox",
  TEXTAREA = "textarea",
  FILE = "file",
}

export interface ValidationRule {
  type: string;
  value: any;
  message?: string;
}

export interface FieldOption {
  label: string;
  value: string;
}

export interface FormField {
  id: string;
  label: string;
  input_type: InputType;
  required: boolean;
  placeholder?: string;
  options?: FieldOption[];
  validation_rules?: ValidationRule[];
}

export interface ServiceFormConfiguration {
  _id?: string;
  service_id: string;
  fields: FormField[];
}
